import React, { useState } from 'react';
import { FaChartLine, FaFile, FaClock, FaInbox } from 'react-icons/fa';
import { RW_ReporteCierres } from './RW_ReporteCierres';
import { RW_TiradasAlBuzon } from './RW_TiradasAlBuzon';

export const RW_Minimercado = () => {
    require('../../Remotework.css?v=1.1.0');
    const [selectedView, setSelectedView] = useState("estadisticas");

    return (
        <div>
            <div className="container-fluid py-4">
                <div className="mb-3">
                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "estadisticas" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("estadisticas")}
                    >
                        <FaChartLine /> Estadísticas
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "cierres" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("cierres")}
                    >
                        <FaClock /> Cierre de turno
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "reportes" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("reportes")}
                    >
                        <FaFile /> Reportes
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "tiradas" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("tiradas")}
                    >
                        <FaInbox /> Tiradas al Buzón
                    </button>
                </div>

                {selectedView === "estadisticas" && (
                    <div className="card p-4 shadow-sm" style={{ margin: '0 auto' }}>
                        <h3 className="text-primary">Estadísticas de Minimercado</h3>
                        <center><p>Proximamente...</p></center>
                    </div>
                )}

                {selectedView === "cierres" && (
                    <RW_ReporteCierres tipoModulo="Shop" />
                )}

                {selectedView === "reportes" && (
                    <div className="card p-4 shadow-sm" style={{ margin: '0 auto' }}>
                        <h3 className="text-primary">Reportes de Minimercado</h3>
                        <center><p>Proximamente...</p></center>
                    </div>
                )}

                {selectedView === "tiradas" && (
                    <RW_TiradasAlBuzon tipoModulo="Shop" />
                )}
            </div>
        </div>
    );
};
